import { render } from "./ChatWidget.vue?vue&type=template&id=414457ec&scoped=true"
import script from "./ChatWidget.js?vue&type=script&lang=js&external"
export * from "./ChatWidget.js?vue&type=script&lang=js&external"

import "./ChatWidget.vue?vue&type=style&index=0&id=414457ec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-414457ec"],['__file',"src/Components/ChatWidget/ChatWidget/ChatWidget.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "414457ec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('414457ec', __exports__)) {
    api.reload('414457ec', __exports__)
  }
  
  module.hot.accept("./ChatWidget.vue?vue&type=template&id=414457ec&scoped=true", () => {
    api.rerender('414457ec', render)
  })

}


export default __exports__